import Unauthorized from "../pages/Unauthorized.vue";
import Index from "../pages/Index.vue";
import CreateIndex from '../pages/CreateIndex.vue';
import IndexDeleted from '../pages/IndexDeleted.vue';

const routes = [
  {
    path: "/",
    redirect: "/index/smxusd",
    meta: { authorizedRoles: ["Research", "IT", "Admin"] },
  },
  {
    path: "/createindex",
    component: CreateIndex,
    meta: { authorizedRoles: ["Research", "IT", "Admin"]}
  },
  {
    path: "/index/:index",
    component: Index,
    props: true,
    meta: { authorizedRoles: ["Research", "IT", "Admin"] },
  },
  {
    path: "/index/custom/:index",
    component: Index,
    props: route => 
      ({
        index: route.params.index,
        isCustom: true
      }),
    meta: { authorizedRoles: ["Research", "IT", "Admin"] },
  },
  {
    path: "/indexDeleted",
    component: IndexDeleted,
    meta: { authorizedRoles: ["Research", "IT", "Admin"] },
  },
  {
    path: "/unauthorized",
    component: Unauthorized,
  },    
];

export default routes;
